import { orderTestServiceCloud } from "@/services/orderTestRequest";

export function editOrderApi(data) {
  return orderTestServiceCloud({
    url: "/patientPage/editOrder",
    method: "post",
    data
  });
}

export function modifyChargeMethodApi(data) {
  return orderTestServiceCloud({
    url: "/patientPage/modifyChargeMethod",
    method: "post",
    data
  })
}

export function sendNYWaiveFormEmailApi(data) {
  return orderTestServiceCloud({
    url: "/patientPage/sendNYWaiveFormEmail",
    method: "post",
    data
  })
}

export function generateNyFormPdfApi(params) {
  return orderTestServiceCloud({
    url: "/patientPage/generateNyFormPdf",
    method: "get",
    params
  })
}

export function getBillingSampleInfoV2Api(params) {
  return orderTestServiceCloud({
    url: "/patientPage/getBillingSampleInfoV2",
    method: "get",
    params
  })
}

export function cancelOrderApi(data) {
  return orderTestServiceCloud({
    url: "patientPage/cancelOrder",
    method: "post",
    data
  })
}

export function getOriginalKitShippingMethodByTypeApi(params) {
  return orderTestServiceCloud({
    url: "patientPage/getOriginalKitShippingMethodByType",
    method: "get",
    params
  })
}

export function recordRedrawKitShippingMethodApi(data) {
  return orderTestServiceCloud({
    url: "patientPage/recordRedrawKitShippingMethod",
    method: "post",
    data
  })
}

export function recordRedrawKitShippingMethodBetaApi(data) {
  return orderTestServiceCloud({
    url: "patientPage/recordRedrawKitShippingMethodBeta",
    method: "post",
    data
  })
}